import { Injectable } from '@angular/core';
import moment from 'moment';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class ChartsService {

  refreshFiltersSubject: Subject<boolean> = new Subject<boolean>();
  removeFilterSubject: Subject<any> = new Subject<any>();
  openFiltersSubject: Subject<boolean> = new Subject<boolean>();
  chipsSubject: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);
  selectedTabSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  toggleMoreFilterSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  productionDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);
  goHome: BehaviorSubject<any> = new BehaviorSubject<any>('auto');
  searchTermSubject: BehaviorSubject<{ page: string, term: string }> = new BehaviorSubject<{ page: string, term: string }>({ page: '', term: '' });

  getChips(activeFilters: any): any {
    let priorityChips = [];
    let allChips = [];

    Object.keys(activeFilters).forEach(key => {
      if (activeFilters[key]?.length) {
        if (Array.isArray(activeFilters[key])) {
          activeFilters[key].forEach(filter => {
            const chip = { name: filter, value: filter, type: key };
            if (filter.startsWith('All ')) {
              allChips.push(chip);
            } else {
              priorityChips.push(chip);
            }
          });
        } else {
          if (key === 'dateType') {
            if (activeFilters['dateType'].toLowerCase() === 'custom') {
              const name = `Custom (${moment(activeFilters.startDate).format('YYYY-MM-DD')} to ${moment(activeFilters.endDate).format('YYYY-MM-DD')})`;
              priorityChips.push({ name, value: activeFilters[key], type: key });
            } else {
              const chip = { name: activeFilters[key], value: activeFilters[key], type: key };
              if (chip.value.startsWith('All ')) {
                allChips.push(chip);
              } else {
                priorityChips.push(chip);
              }
            }
          } else if (key !== 'agency') {
            const chip = { name: activeFilters[key], value: activeFilters[key], type: key };
            if (chip.value.startsWith('All ')) {
              allChips.push(chip);
            } else {
              priorityChips.push(chip);
            }
          }
        }
      }
    });

    const chips = [...priorityChips, ...allChips];
    this.chipsSubject.next(chips);
    return chips;
  }
}